export enum WellKnownRoutes {
  AccountManagement = 'account-management',
  ChangePassword = 'change-password',
  Dashboard = 'dashboard',
  Paystubs = 'paystubs',
  Personal = 'personal',
  Profile = 'profile',
  TaxForms = 'tax-forms',
  Address = 'address',
}
